import { axiosInstance } from "@/lib/api";

/**
 * Voice is only a way to type (Figma 05 · Voice): the recording goes to the
 * bucket, the backend writes it down, and only the words come back. It is never
 * registered as a chat file, so nothing of the recording shows in the composer
 * or the conversation. The upload is signed like any attachment (that is the
 * key the transcription reads), but without /process no document is made.
 */
export async function transcribeVoiceNote(brandId: string, file: File): Promise<string> {
  const extension = file.name.includes(".") ? (file.name.split(".").pop() ?? "webm") : "webm";
  const { data } = await axiosInstance.post<{ uploadUrl: string; s3Key: string }>(
    `/brand/${brandId}/attachments/upload-url`,
    { filename: file.name, mimetype: file.type, extension },
  );
  const put = await fetch(data.uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!put.ok) throw new Error("The recording didn't upload. Try again, or type instead.");
  const res = await axiosInstance.post<{ text: string }>(`/brand/${brandId}/attachments/transcribe`, {
    s3Key: data.s3Key,
  });
  return res.data.text.trim();
}
